import { DxButtonModule, DxGanttModule, DxHtmlEditorModule } from 'devextreme-angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonGroupComponent } from './button-group.component';



@NgModule({
	declarations: [ButtonGroupComponent],
	exports: [ButtonGroupComponent],
  imports: [
		CommonModule,
		DxButtonModule,
		DxGanttModule,
		DxHtmlEditorModule,
  ]
})
export class ButtonGroupModule { }
